import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from 'utils/services';

import {
  AddHealthMetricsResProps,
  DeleteHealthMetricReqProps,
  DeleteHealthMetricResProps,
  GetChartHealthMetricsReqProps,
  GetChartHealthMetricsResProps,
  GetHealthMetricsReqProps,
  GetHealthMetricsResProps,
  GetLatestHealthMetricsReqProps,
  GetLatestHealthMetricsResProps,
  HealthMetrics,
  SetHealthMetricsReqProps,
  UpdateHealthMetricsResProps
} from './healthMetrics.types';

export const healthMetricsApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    addHealthMetrics: build.mutation<AddHealthMetricsResProps, SetHealthMetricsReqProps>({
      query: ({ accessToken, ...body }) => ({
        body,
        headers: {
          ...(accessToken && { Authorization: accessToken })
        },
        method: 'POST',
        url: '/health-metrics'
      })
    }),
    deleteHealthMetric: build.mutation<DeleteHealthMetricResProps, DeleteHealthMetricReqProps>({
      query: ({ collectedDate, metricType }) => ({
        method: 'DELETE',
        url: `/health-metrics/${collectedDate}/${metricType}`
      })
    }),
    getChartHealthMetrics: build.query<
      GetChartHealthMetricsResProps,
      GetChartHealthMetricsReqProps
    >({
      query: (params) => ({
        params,
        url: '/chart-health-metrics'
      })
    }),
    getHealthMetrics: build.query<GetHealthMetricsResProps, GetHealthMetricsReqProps>({
      query: (params) => ({
        params,
        url: '/health-metrics'
      })
    }),
    getLatestHealthMetrics: build.query<HealthMetrics, GetLatestHealthMetricsReqProps>({
      keepUnusedDataFor: 0,
      query: () => '/latest-health-metrics',
      transformResponse: (response: GetLatestHealthMetricsResProps) => response.data
    }),
    updateHealthMetrics: build.mutation<UpdateHealthMetricsResProps, SetHealthMetricsReqProps>({
      query: ({ accessToken, ...body }) => ({
        body,
        headers: {
          ...(accessToken && { Authorization: accessToken })
        },
        method: 'PATCH',
        url: '/health-metrics'
      })
    })
  }),
  reducerPath: 'healthMetricsApi',
  tagTypes: ['HealthMetrics']
});

export const {
  useAddHealthMetricsMutation,
  useDeleteHealthMetricMutation,
  useGetChartHealthMetricsQuery,
  useGetHealthMetricsQuery,
  useGetLatestHealthMetricsQuery,
  useLazyGetChartHealthMetricsQuery,
  useLazyGetHealthMetricsQuery,
  useLazyGetLatestHealthMetricsQuery,
  useUpdateHealthMetricsMutation
} = healthMetricsApi;
